import { Unlimited } from '../models/skyclub.interfaces';

export const NonUnlimitedMocks: Unlimited = {
  unlocked: false,
  membership: false,
  image: {
    src: '',
    alt: ''
  },
  title: '',
  subtitle: ''
};

export const UnlimitedCardMocks: Unlimited = {
  unlocked: true,
  membership: false,
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/skyclub-unlimited-fireworks.png',
    alt: 'Unlimited Skyclub Image image'
  },
  title: "You've unlocked unlimited Delta Sky Club® access.",
  subtitle: 'Valid through Jan 31, 2026',
  terms: {
    label: 'Terms Apply',
    url: '/us/en/delta-sky-club/access',
    id: 'cardSpendTermsApply'
  },
  skyclub: {
    label: 'Plan to visit a Delta Sky Club for your next trip.',
    eligible: {
      id: 'eligibleSkyclub',
      label: 'Search for Eligible Delta Sky Clubs',
      url: ''
    }
  }
};

export const UnlimitedMembershipMocks: Unlimited = {
  unlocked: true,
  membership: true,
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/skyclub-unlimited-fireworks.png',
    alt: 'Unlimited Skyclub Image image'
  },
  title: 'Enjoy your unlimited Delta Sky Club® access.',
  subtitle: 'Valid through Feb 31, 2026',
  skyclub: {
    label: 'Plan to visit a Delta Sky Club for your next trip.',
    eligible: {
      id: 'eligibleSkyclub',
      label: 'Search for Eligible Delta Sky Clubs',
      url: ''
    }
  }
};
